import { useEffect, useState } from 'react';
import { getPublicStreamers, type PublicStreamer } from '@/shared/services/streamerService';
import { SectionTitle, Ornament } from './SectionTitle';

const PLATFORM_LABEL: Record<string, string> = {
  twitch: 'Twitch', youtube: 'YouTube', kick: 'Kick', tiktok: 'TikTok',
};

function StreamerCard({ s }: { s: PublicStreamer }) {
  // pf-<plataforma> = cor da plataforma na borda/avatar/selo (twitch roxo, youtube vermelho...)
  // plataforma vazia (null) = YouTube (canal cadastrado sem plataforma -> aparecia "Canal")
  const pf = String(s.platform || 'youtube').toLowerCase();
  const pfClass = PLATFORM_LABEL[pf] ? ` pf-${pf}` : '';
  return (
    <a className={`streamer-card${s.live ? ' live' : ''}${pfClass}`} href={s.channelUrl || '#'} target="_blank" rel="noopener noreferrer">
      {s.avatar
        ? <img className="streamer-avatar" src={s.avatar} alt={s.nick} />
        : <span className="streamer-avatar">{(s.nick || '?').charAt(0)}</span>}
      <h3>{s.nick}</h3>
      <span className="platform">{PLATFORM_LABEL[pf] ?? s.platform}</span>
      {s.live ? (
        <span className="streamer-status live">
          <i></i> Ao vivo{s.viewers != null ? ` · ${s.viewers.toLocaleString('pt-BR')}` : ''}
        </span>
      ) : (
        <span className="streamer-status">Offline</span>
      )}
      <span className="tiny-btn">Ver canal <span>›</span></span>
    </a>
  );
}

/** Streamers oficiais + parceiros — grade no estilo de Sistemas & Diferenciais. Some se nao houver nenhum. */
export function StreamersSection() {
  const [streamers, setStreamers] = useState<PublicStreamer[]>([]);

  useEffect(() => {
    getPublicStreamers()
      .then((list) => setStreamers([...list].sort((a, b) => (a.live === b.live ? 0 : a.live ? -1 : 1))))
      .catch(() => setStreamers([]));
  }, []);

  if (streamers.length === 0) return null;

  return (
    <>
      <Ornament />
      <section className="section streamers" id="streamers">
        <div className="shell">
          <SectionTitle title="Streamers & Parceiros" subtitle="Apoie os criadores de conteúdo oficiais da comunidade Liberty." reveal={false} />
          <div className="streamers-grid">
            {streamers.map((s) => <StreamerCard key={s.id} s={s} />)}
          </div>
        </div>
      </section>
    </>
  );
}
